// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Customer_Portal_HealthResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Customer_Portal_HealthResponseDados {
status: string
version: string
}

export type Customer_Portal_HealthResponse = ApiResponse<Customer_Portal_HealthResponseDados>;

registerResponseContract('Customer_Portal_HealthResponse', {
  status:  { type: 'string',  required: true },
  version: { type: 'string',  required: true },
})
